import { useCallback } from 'react';

import { type AirActionTrackingLocation, useTrackClickedFolderUpload } from '@air/analytics';

import { useUploadContext } from '~/components/PrivateDropzone/UploadContext';
import { useActiveSubscriptionCallback } from '~/swr-hooks/subscriptions/useActiveSubscriptionCallback';

export type UseUploadFoldersFromComputerParams = {
  trackLocation: AirActionTrackingLocation;
  pickDestination?: boolean;
};

export const useUploadFoldersFromComputer = ({
  trackLocation,
  pickDestination,
}: UseUploadFoldersFromComputerParams) => {
  const { openUploader } = useUploadContext();
  const { activeSubscriptionCallback } = useActiveSubscriptionCallback();
  const { trackClickedFolderUpload } = useTrackClickedFolderUpload();

  const uploadFoldersFromComputer = useCallback(
    () =>
      activeSubscriptionCallback(() => {
        openUploader(pickDestination ? { type: 'folders', pickDestination: true } : { type: 'folders' });
        trackClickedFolderUpload({ location: trackLocation });
      }),
    [activeSubscriptionCallback, openUploader, pickDestination, trackLocation, trackClickedFolderUpload],
  );

  return {
    uploadFoldersFromComputer,
  };
};
